import { gsap } from 'gsap';
export const contactAnimation = () => {
  const target = document.querySelector('.load-overlay');
  if (target) {
    const tl = gsap.timeline({ delay: 1 });
    tl.set('.contact__form', { width: 0, opacity: 0 });
    tl.set('h2', { y: 200 });
    tl.set('.map', { height: 0 });
    tl.set('.address', { opacity: 0, y: 50 });
    tl.to(target, { opacity: 0, duration: 1 });
    tl.set(target, { y: -2000 });
    tl.to('h2', { y: 0 }, 'match');
    tl.to('.contact__form', { width: 'auto', opacity: 1 }, 'match2');
    tl.to('.map', { height: '100%' }, 'match');
    tl.to('.address', { opacity: 1, y: 0 }, 'match2');
  }
};
